<template>
     <div>
        <div id="fb-root"></div>
        <div class="fb-page" :data-href="facebookPage" data-width="500" data-height="600"  data-tabs="timeline" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/BBNCuitgevers/" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/BBNCuitgevers/">BBNC uitgevers</a></blockquote></div>    
    </div>

</template>
<script>
export default {
    name:"sidebar-facebook",
    props:{
        facebookPage:String
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/overall_layouts/sidebar-facebook.vue